import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';

const BASE = 'Join Our Place';

/**
 * Sets the document title from the matched route's `handle.title`.
 *
 * Every page on the site shared one static title from index.html. With full
 * page reloads that was merely bad for SEO and for telling two open tabs apart.
 * Now that navigation is client-side it is also an accessibility problem: the
 * title is what a screen reader announces when the route changes, so every
 * navigation announced the same sentence.
 *
 * Routes without a `handle.title` are left alone — Our Places v2 sets its own
 * titles from the live search, and this must not fight it.
 */
const useRouteTitle = () => {
  const matches = useMatches();

  // Deepest match wins, so a child route can override its parent.
  const title = [...matches].reverse().find((m) => m.handle?.title)?.handle.title;

  useEffect(() => {
    if (!title) return;
    document.title = title === BASE ? BASE : `${title} | ${BASE}`;
  }, [title]);
};

export default useRouteTitle;
